import { Component, OnInit } from '@angular/core';


import { Router, ActivatedRoute , ParamMap} from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';
import { CommerceDataService } from '../../../services/commerce-data.service';
import { environment } from '../../../../environments/environment';

declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-sale-details-modal',
  templateUrl: './sale-details-modal.component.html',
  styleUrls: ['./sale-details-modal.component.css']
})
export class SaleDetailsModalComponent implements OnInit {

  modelData;
  orderRef = "";
  orderStatus = ""
  userId
  saleId 
  saleItems = []
  subscription;
  queryParams
  modelReady = false;
  totalInclusive = 0

  p: number = 1;
  itemsPerPage = 15;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    this.queryParams = this._data.queryParams;

    //lets create a subscription of 
    this.subscription = this._data.queryParamsChanged.subscribe(
      (data) => {
        this.queryParams = data;

        if(this.queryParams.saleId != undefined) {
            
            $('#loader').show();

            this.saleId = this.queryParams.saleId;

            this.userId = sessionStorage.getItem('context')

            if(!this.userId && !this.saleId) {
                $('#loader').hide();
                // redirect to login 
                // return false;
            }

            else
              this.getSaleDetails()
        }
        
      }
    );

    

    
  }

  getSaleDetails() {

    let queryData = new FormData();
    queryData.append('modelName', 'Sale');
    queryData.append('mid', this.saleId);
    queryData.append('context_id', this.userId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.modelData = data['covers'][0]['cover']['model']['modelData'];
          this.orderStatus = this.modelData['systemManagedEntities']['saleDetails']['collectionFromSellerStatus'];
          this.orderRef = this.modelData['systemManagedEntities']['saleDetails']['transactionRef'];
          this.saleItems = this.modelData['systemManagedEntities']['saleDetails']['items'];
          this.modelReady = true;

          let totalAmount = this.modelData['systemManagedEntities']['saleDetails']['totalAmount'];
          let transactionFee = this.modelData['systemManagedEntities']['saleDetails']['transactionFee'];
          let totalTax = this.modelData['systemManagedEntities']['saleDetails']['totalTax'];

          this.totalInclusive = parseFloat(totalAmount) + parseFloat(transactionFee) + parseFloat(totalTax);
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

}
